// Same result as Django's slugify, which the API uses to tell names apart
export function slugify(value: string): string {
  const ascii = value.normalize('NFKD').replace(/[^\x00-\x7F]/g, '');

  return ascii.replace(/[^\w\s-]/g, '').trim().toLowerCase().replace(/[-\s]+/g, '-');
}
